webpackJsonp([29],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(77);

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download


function download(data, strFileName, strMimeType, headers, finishCb) {

  var self = window,
      // this script is only for browsers anyway...
  defaultMime = "application/octet-stream",
      // this default mime also triggers iframe downloads
  mimeType = strMimeType || defaultMime,
      payload = data,
      url = !strFileName && !strMimeType && payload,
      anchor = document.createElement("a"),
      toString = function toString(a) {
    return String(a);
  },
      myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
      fileName = strFileName || "download",
      blob,
      reader;
  myBlob = myBlob.call ? myBlob.bind(self) : Blob;

  if (String(this) === "true") {
    //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
    payload = [payload, mimeType];
    mimeType = payload[0];
    payload = payload[1];
  }

  if (url && url.length < 2048) {
    // if no filename and no mime, assume a url was passed as the only argument
    fileName = url.split("/").pop().split("?")[0];
    anchor.href = url; // assign href prop to temp anchor
    // if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
    var ajax = new XMLHttpRequest();
    ajax.open("GET", url, true);
    ajax.responseType = 'blob';
    for (var _i in headers) {
      if (headers.hasOwnProperty(_i)) {
        ajax.setRequestHeader(_i, headers[_i]);
      }
      // }
      ajax.onload = function (e) {
        download(e.target.response, fileName, defaultMime, headers, finishCb);
      };
      setTimeout(function () {
        ajax.send();
      }, 0); // allows setting custom ajax headers using the return:
      return ajax;
    } // end if valid url?
  } // end if url?


  //go ahead and download dataURLs right away
  if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {

    if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
      payload = dataUrlToBlob(payload);
      mimeType = payload.type || defaultMime;
    } else {
      return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
      navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
    }
  } else {
    //not data url, is it a string with special needs?
    if (/([\x80-\xff])/.test(payload)) {
      var i = 0,
          tempUiArr = new Uint8Array(payload.length),
          mx = tempUiArr.length;
      for (i; i < mx; ++i) {
        tempUiArr[i] = payload.charCodeAt(i);
      }payload = new myBlob([tempUiArr], { type: mimeType });
    }
  }
  blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

  function dataUrlToBlob(strUrl) {
    var parts = strUrl.split(/[:;,]/),
        type = parts[1],
        decoder = parts[2] == "base64" ? atob : decodeURIComponent,
        binData = decoder(parts.pop()),
        mx = binData.length,
        i = 0,
        uiArr = new Uint8Array(mx);

    for (i; i < mx; ++i) {
      uiArr[i] = binData.charCodeAt(i);
    }return new myBlob([uiArr], { type: type });
  }

  function saver(url, winMode) {

    if ('download' in anchor) {
      //html5 A[download]
      anchor.href = url;
      anchor.setAttribute("download", fileName);
      anchor.className = "download-js-link";
      anchor.innerHTML = "downloading...";
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      setTimeout(function () {
        anchor.click();
        document.body.removeChild(anchor);
        if (winMode === true) {
          setTimeout(function () {
            self.URL.revokeObjectURL(anchor.href);
          }, 250);
        }
        if (finishCb) {
          finishCb();
        }
      }, 66);
      return true;
    }

    // handle non-a[download] safari as best we can:
    if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
      if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
      if (!window.open(url)) {
        // popup blocked, offer direct download:
        if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
          location.href = url;
        }
      }
      return true;
    }

    //do iframe dataURL download (old ch+FF):
    var f = document.createElement("iframe");
    document.body.appendChild(f);

    if (!winMode && /^data:/.test(url)) {
      // force a mime that will download:
      url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
    }
    f.src = url;
    setTimeout(function () {
      document.body.removeChild(f);
    }, 333);
  } //end saver


  if (navigator.msSaveBlob) {
    // IE10+ : (has Blob, but not a[download] or URL)
    return navigator.msSaveBlob(blob, fileName);
  }

  if (self.URL) {
    // simple fast and modern way using Blob and URL:
    saver(self.URL.createObjectURL(blob), true);
  } else {
    // handle non-Blob()+non-URL browsers:
    if (typeof blob === "string" || blob.constructor === toString) {
      try {
        return saver("data:" + mimeType + ";base64," + self.btoa(blob));
      } catch (y) {
        return saver("data:" + mimeType + "," + encodeURIComponent(blob));
      }
    }

    // Blob but not URL support:
    reader = new FileReader();
    reader.onload = function (e) {
      saver(this.result);
    };
    reader.readAsDataURL(blob);
  }
  return true;
}; /* end download() */

/* harmony default export */ __webpack_exports__["a"] = (download);

/***/ }),

/***/ 1927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendor_download__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__(77);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [],
  components: {},
  data: function data() {
    return {
      visible: false,
      fileList: [],
      customerid: null,
      name: null,
      number: null,
      form: [],
      load: false,
      expImgUrl: '/static/img/customer-receipt.png'
    };
  },

  methods: {
    openDialog: function openDialog(customer) {
      var _this = this;

      // 清空并设置所需字段
      this.customerid = customer.customerid;
      this.name = customer.name;
      this.number = customer.number;
      var id = this.customerid;
      this.form = [];

      // 获取该客户下所有发票信息
      request.page('getCustomerReceiptInfo', { customerid: id }).then(function (_ref) {
        var data = _ref.data;

        _this.visible = true;
        for (var i = 0; i < data.length; i++) {
          _this.form.push(data[i]);
          _this.form[i].attached_file = _this.form[i].attached_file.filter(function (item) {
            return item;
          });
        }
      });
    },
    onGetPdfFile: function onGetPdfFile(item) {
      var _this2 = this;

      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__vendor_download__["a" /* default */])(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["c" /* getToken */])()
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '下载已取消'
        });
      });
    },
    onViewImage: function onViewImage(event) {
      if (event.target.src) {
        this.views = new __WEBPACK_IMPORTED_MODULE_1_viewerjs___default.a(event.target, {
          url: function url(image) {
            return event.target.src;
          }
        });
      }
      this.views.view();
    }
  }
});

/***/ }),

/***/ 2154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的客户开票信息ID', 'integer', 'blur', false), { min: 1 })]

  // export let formRules = {
  //   company_name: [
  //     {...makeRule('请输入公司名称', 'string')},
  //   ],
  //   bank_info: [
  //     {...makeRule('请输入开户行及账户', 'string')},
  //   ],
  //   address_phone: [
  //     {...makeRule('请输入地址及电话', 'string')},
  //   ],
  //   tax_number: [
  //     {...makeRule('请输入税号', 'string')},
  //   ],
  // }

};var formRules = {
  company_name: [{ required: true, message: '公司名称不能为空', trigger: 'blur' }],
  bank_info: [{ required: true, message: '开户行及账号不能为空', trigger: 'blur' }],
  address_phone: [{ required: true, message: '地址及电话不能为空', trigger: 'blur' }],
  tax_number: [{ required: true, message: '税号不能为空', trigger: 'blur' }, {
    pattern: /^[0-9a-zA-Z]+$/,
    message: '格式不正确',
    trigger: 'blur'
  }],
  customer_ids: [{ required: true, message: '使用客户不能为空', trigger: 'blur' }],
  pay_condition_ids: [{ required: true, message: '账期不能为空', trigger: 'blur' }]
};

/***/ }),

/***/ 2155:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2156);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2ab0ba72", content, true, {});

/***/ }),

/***/ 2156:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".receipt-detail[data-v-0a446ce8]{font-size:20px;margin-left:50px}.medium[data-v-0a446ce8]{width:700px}.form-item[data-v-0a446ce8]{width:580px}.el-dialog-div[data-v-0a446ce8]{overflow:auto}.receipt-button[data-v-0a446ce8]{margin:0 0 10px}.view-navbar[data-v-0a446ce8]{right:0;bottom:0;width:100%;overflow:hidden;display:inline;float:left}ul[data-v-0a446ce8]{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transition:all .3s;transition:all .3s;-webkit-box-sizing:content-box;box-sizing:content-box;overflow:hidden;padding:1px 0}li[data-v-0a446ce8]{float:left;list-style:none;width:100px;height:100px;margin-right:5px;cursor:pointer;font-size:0;line-height:0;overflow:hidden;-webkit-transition:opacity .15s;transition:opacity .15s}.flex-jc-end[data-v-0a446ce8]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.flex-ai-start[data-v-0a446ce8],.flex-jc-end[data-v-0a446ce8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-ai-start[data-v-0a446ce8]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}", "", {"version":3,"sources":["/workspace/src/views/customer/components/CustomerReceiptForm.vue"],"names":[],"mappings":"AACA,iCACE,eAAgB,AAChB,gBAAkB,CACnB,AACD,yBACE,WAAa,CACd,AACD,4BACE,WAAa,CACd,AACD,gCACE,aAAe,CAChB,AACD,iCACE,eAAmB,CACpB,AACD,8BACE,QAAW,AACX,SAAY,AACZ,WAAY,AACZ,gBAAiB,AACjB,eAAgB,AAChB,UAAY,CACb,AACD,oBACE,gCAAmC,AAC3B,wBAA2B,AACnC,2BAA6B,AAC7B,mBAAqB,AACrB,+BAAgC,AACxB,uBAAwB,AAChC,gBAAiB,AACjB,aAAe,CAChB,AACD,oBACE,WAAY,AACZ,gBAAiB,AACjB,YAAa,AACb,aAAc,AACd,iBAAkB,AAClB,eAAgB,AAChB,YAAa,AACb,cAAe,AACf,gBAAiB,AACjB,gCAAkC,AAClC,uBAA0B,CAC3B,AACD,8BAQE,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACnC,AACD,8DAXE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,kBAAoB,CAgB7B,AAXD,gCAQE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC","file":"CustomerReceiptForm.vue","sourcesContent":["\n.receipt-detail[data-v-0a446ce8] {\n  font-size: 20px;\n  margin-left: 50px;\n}\n.medium[data-v-0a446ce8] {\n  width: 700px;\n}\n.form-item[data-v-0a446ce8] {\n  width: 580px;\n}\n.el-dialog-div[data-v-0a446ce8] {\n  overflow: auto;\n}\n.receipt-button[data-v-0a446ce8] {\n  margin: 0 0 10px 0;\n}\n.view-navbar[data-v-0a446ce8] {\n  right: 0px;\n  bottom: 0px;\n  width: 100%;\n  overflow: hidden;\n  display: inline;\n  float: left;\n}\nul[data-v-0a446ce8] {\n  -webkit-transform: translateX(0px);\n          transform: translateX(0px);\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  overflow: hidden;\n  padding: 1px 0;\n}\nli[data-v-0a446ce8] {\n  float: left;\n  list-style: none;\n  width: 100px;\n  height: 100px;\n  margin-right: 5px;\n  cursor: pointer;\n  font-size: 0;\n  line-height: 0;\n  overflow: hidden;\n  -webkit-transition: opacity 0.15s;\n  transition: opacity 0.15s;\n}\n.flex-jc-end[data-v-0a446ce8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.flex-ai-start[data-v-0a446ce8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('el-dialog',{attrs:{"visible":_vm.visible,"title":"客户开票信息","width":"60%","max-height":"300px"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"el-dialog-div"},[_c('el-row',{staticStyle:{"margin-bottom":"30px"}},[_c('el-col',{attrs:{"span":22}},[_c('span',{staticClass:"receipt-detail"},[_vm._v("客户名称："+_vm._s(_vm.name))])]),_vm._v(" "),_c('el-col',{attrs:{"span":22}},[_c('span',{staticClass:"receipt-detail"},[_vm._v("客户编号："+_vm._s(_vm.number))])])],1),_vm._v(" "),_vm._l((_vm.form),function(detailItem,itemIndex){return _c('el-form',{key:itemIndex,ref:"form",refInFor:true,attrs:{"model":detailItem,"size":"medium","label-width":"120px"}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium",staticStyle:{"position":"relative"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"公司名称","prop":"company_name"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":detailItem.company_name,"placement":"top"}},[_c('span',[_vm._v(_vm._s(detailItem.company_name))])])],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"开户行及账号","prop":"bank_info"}},[_c('span',[_vm._v(_vm._s(detailItem.bank_info))])]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"地址及电话","prop":"address_phone"}},[_c('span',[_vm._v(_vm._s(detailItem.address_phone))])]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"税号","prop":"tax_number"}},[_c('span',[_vm._v(_vm._s(detailItem.tax_number))])]),_vm._v(" "),(detailItem.attached_file.length)?_c('el-form-item',{attrs:{"label":""}},[[_c('div',{staticClass:"view-navbar"},[_c('ul',{staticClass:"clear-both"},_vm._l((detailItem.attached_file),function(item,index){return _c('li',{key:index},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":item.name,"placement":"bottom"}},[(item.type === 'pic')?_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":item.tmp_url},on:{"click":_vm.onViewImage}}):_vm._e(),_vm._v(" "),(item.type === 'pdf' || item.type === 'eml')?_c('i',{staticClass:"sj-icon-pdf",staticStyle:{"font-size":"100px","margin-top":"50px"},on:{"click":function($event){return _vm.onGetPdfFile(item, index)}}}):_vm._e()])],1)}),0)])]],2):_vm._e(),_vm._v(" "),(itemIndex < _vm.form.length - 1)?_c('hr',{staticStyle:{"border":"1px dashed","color":"#999","margin-bottom":"20px"}}):_vm._e()],1)])])}),_vm._v(" "),_c('div',[_c('hr',{staticStyle:{"border":"1px dashed","color":"#999","margin-bottom":"20px"}}),_vm._v(" "),_c('p',[_vm._v("注：如需新增或修改开票信息，请发邮件给财务开票的同事。")]),_vm._v(" "),_c('p',[_vm._v("邮件内容请注明：")]),_vm._v(" "),_c('p',[_vm._v("1、新增开票信息或修改开票信息；")]),_vm._v(" "),_c('p',[_vm._v("2、客户名称，客户ID；（如：“客户名称：零启营销，客户ID：353”）；")]),_vm._v(" "),_c('p',[_vm._v("3、客户最新的开票信息：公司名称、开户行及账号、地址及电话、税号；")]),_vm._v(" "),_c('p',[_vm._v("4、客户提供的开票信息的证明文件。")]),_vm._v(" "),_c('div',{staticClass:"flex-ai-start"},[_c('span',{staticStyle:{"margin-right":"6px"}},[_vm._v("示例")]),_vm._v(" "),_c('el-image',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.expImgUrl,"preview-src-list":[_vm.expImgUrl]}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex-jc-end"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.visible = false}}},[_vm._v("关闭\n        ")])],1)],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendor_download__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_receipt_rules_js__ = __webpack_require__(2154);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      id: 0,
      fileUploading: false,
      formRules: __WEBPACK_IMPORTED_MODULE_6__customer_receipt_rules_js__["a" /* formRules */],
      form: {
        company_name: '',
        bank_info: '',
        address_phone: '',
        tax_number: '',
        attached_file: [],
        customer_ids: [{ id: '' }],
        pay_condition_ids: [{ id: '' }]
      },
      fileList: []
    };
  },

  computed: {},
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['queryPayCondition', 'getPayCondition']), {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getCustomerReceiptDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        data.customer_ids = data.customer_ids.map(function (id) {
          return { id: '' + id };
        });
        if (data.pay_condition_ids.length > 0) {
          data.pay_condition_ids = data.pay_condition_ids.map(function (id) {
            return { id: id };
          });
        } else {
          data.pay_condition_ids = [{ id: '' }];
        }
        filter.setLoop(_this.form, data);
      });
    },
    getForm: function getForm() {
      var form = filter.copyJson(this.form);
      form.customer_ids = form.customer_ids.map(function (item) {
        return item.id;
      }).filter(Boolean);
      form.pay_condition_ids = form.pay_condition_ids.map(function (item) {
        return item.id;
      }).filter(Boolean);
      return form;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        var params = _this2.getForm();
        console.log(params);
        if (params.customer_ids.length < 1) {
          _this2.$message.error('使用客户不得为空！');
          return false;
        }
        if (params.pay_condition_ids.length < 1) {
          _this2.$message.error('账期不得为空！');
          return false;
        }
        if (valid) {
          _this2.id ? _this2.update(_this2.id, params) : _this2.submit(params);
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create(params) {
      var _this3 = this;

      request.common('createCustomerReceiptData', params).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this3.$refs.form.resetFields();
          _this3.$refs.upload.clearFiles();
          _this3.form.customer_ids = [{ id: '' }];
        }, function () {
          _this3.$router.push({ path: '/customer-receipt/table/' });
        });
      });
    },
    submit: function submit(params) {
      var _this4 = this;

      request.common('getCustomerReceiptTable', { tax_number: this.form.tax_number }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.total) {
          _this4.$confirm('该税号已存在，请确认是否添加？', '提示', { type: 'warning' }).then(function () {
            _this4.create(params);
          });
        } else {
          _this4.create(params);
        }
      });
    },
    update: function update(id, params) {
      var _this5 = this;

      request.common('updateReceiptInfoData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, params)).then(function (res) {
        _this5.$confirm(_this5.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this5.$router.push({ path: '/customer-receipt/table/' });
        });
      });
    },
    addCustomer: function addCustomer() {
      this.form.customer_ids.push({
        id: ''
      });
    },
    deleteItemAt: function deleteItemAt(index) {
      this.form.customer_ids.splice(index, 1);
    },
    addConditions: function addConditions() {
      this.form.pay_condition_ids.push({
        id: ''
      });
    },
    deleteConditionAt: function deleteConditionAt(index) {
      this.form.pay_condition_ids.splice(index, 1);
    },
    customerRemoteMethod: function customerRemoteMethod(query) {
      return request.common('getCustomerTableForSearch', { keyword: query.keyword, type: 'all' });
    },
    getCustomerInfoRemote: function getCustomerInfoRemote(id) {
      return request.common('getCustomerDetail', id);
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 5 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ' + files.length + ' \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ' + (files.length + fileList.length) + ' \u4E2A\u6587\u4EF6');
    },
    onChangeFile: function onChangeFile(file, fileList, index) {
      var isLt2M = file.raw.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }
      this.onUploadFile(file.raw, fileList, index);
    },
    onUploadFile: function onUploadFile(file, fileList) {
      var _this6 = this;

      this.fileUploading = true;
      var formData = new FormData();
      formData.append('file', file);
      return request.alert('uploadCustomerReceiptAttachedFile', formData).then(function (_ref3) {
        var data = _ref3.data;

        _this6.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        var index = _this6.getFileListIndex(file, fileList);

        var type = void 0;
        if (file.name.substr(-5).toLowerCase() === '.jpeg' || file.name.substr(-4).toLowerCase() === '.jpg' || file.name.substr(-4).toLowerCase() === '.png') {
          type = 'pic';
        } else if (file.name.substr(-4).toLowerCase() === '.pdf') {
          type = 'pdf';
        } else if (file.name.substr(-4).toLowerCase() === '.eml') {
          type = 'eml';
        }
        if (index > -1) {
          _this6.form.attached_file[index] = { name: file.name, url: data, type: type };
          _this6.fileList[index] = { name: file.name, url: data, type: type };
        }
        _this6.fileUploading = false;
      }, function () {
        _this6.$refs.upload.uploadFiles.pop();
        _this6.fileUploading = false;
      });
    },
    getFileListIndex: function getFileListIndex(file, fileList) {
      for (var i = 0; i < fileList.length; i++) {
        var fileTemp = void 0;
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw;
        } else {
          fileTemp = fileList[i];
        }
        if (file === fileTemp) {
          return i;
        }
      }
      return -1;
    },
    beforeRemove: function beforeRemove(file, fileList) {
      var fileTemp = void 0;
      if (file.raw) {
        fileTemp = file.raw;
      } else {
        fileTemp = file;
      }
      var index = this.getFileListIndex(fileTemp, fileList);
      if (index > -1) {
        this.form.attached_file.splice(index, 1);
      }
    },
    onGetPdfFile: function onGetPdfFile(item) {
      var _this7 = this;

      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__vendor_download__["a" /* default */])(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["c" /* getToken */])()
        });
      }).catch(function () {
        _this7.$message({
          type: 'info',
          message: '下载已取消'
        });
      });
    },
    onViewImage: function onViewImage(event) {
      if (event.target.src) {
        this.views = new __WEBPACK_IMPORTED_MODULE_4_viewerjs___default.a(event.target, {
          url: function url(image) {
            return event.target.src;
          }
        });
      }
      this.views.view();
    }
  })
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptForm_vue__ = __webpack_require__(2627);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f72ef3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptForm_vue__ = __webpack_require__(3790);
function injectStyle (ssrContext) {
  __webpack_require__(3784)
  __webpack_require__(3786)
  this["$style"] = __webpack_require__(3788)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36f72ef3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f72ef3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3784:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3785);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("004c541f", content, true, {});

/***/ }),

/***/ 3785:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CustomerReceiptForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3786:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3787);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("17d65267", content, true, {});

/***/ }),

/***/ 3787:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".view-navbar[data-v-36f72ef3]{right:0;bottom:0;width:100%;overflow:hidden;display:inline;float:left}ul[data-v-36f72ef3]{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transition:all .3s;transition:all .3s;-webkit-box-sizing:content-box;box-sizing:content-box;overflow:hidden;padding:1px 0}li[data-v-36f72ef3]{float:left;list-style:none;width:100px;height:100px;margin-right:5px;cursor:pointer;font-size:0;line-height:0;overflow:hidden;-webkit-transition:opacity .15s;transition:opacity .15s}", "", {"version":3,"sources":["/workspace/src/views/customer-receipt/pages/CustomerReceiptForm.vue"],"names":[],"mappings":"AACA,8BAA8B,QAAU,SAAW,WAAW,gBAAgB,eAAe,UAAU,CACtG,AACD,oBAAoB,gCAAkC,wBAA0B,2BAA4B,mBAAoB,+BAA+B,uBAAuB,gBAAgB,aAAa,CAClN,AACD,oBAAoB,WAAW,gBAAgB,YAAY,aAAa,iBAAiB,eAAe,YAAY,cAAc,gBAAgB,gCAAiC,uBAAwB,CAC1M","file":"CustomerReceiptForm.vue","sourcesContent":["\n.view-navbar[data-v-36f72ef3]{right:0px;bottom:0px;width:100%;overflow:hidden;display:inline;float:left\n}\nul[data-v-36f72ef3]{-webkit-transform:translateX(0px);transform:translateX(0px);-webkit-transition:all 0.3s;transition:all 0.3s;-webkit-box-sizing:content-box;box-sizing:content-box;overflow:hidden;padding:1px 0\n}\nli[data-v-36f72ef3]{float:left;list-style:none;width:100px;height:100px;margin-right:5px;cursor:pointer;font-size:0;line-height:0;overflow:hidden;-webkit-transition:opacity 0.15s;transition:opacity 0.15s\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3788:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3789);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("318ddd69", content, true, {});

/***/ }),

/***/ 3789:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CustomerReceiptForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/customer-receipt/table"}},[_vm._v("客户开票信息列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"公司名称","prop":"company_name"}},[_c('el-input',{attrs:{"placeholder":"请输入公司名称","disabled":_vm.id > 0},model:{value:(_vm.form.company_name),callback:function ($$v) {_vm.$set(_vm.form, "company_name", $$v)},expression:"form.company_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开户行及账户","prop":"bank_info"}},[_c('el-input',{attrs:{"placeholder":"请输入开户行及账户"},model:{value:(_vm.form.bank_info),callback:function ($$v) {_vm.$set(_vm.form, "bank_info", $$v)},expression:"form.bank_info"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"地址及电话","prop":"address_phone"}},[_c('el-input',{attrs:{"placeholder":"请输入地址及电话"},model:{value:(_vm.form.address_phone),callback:function ($$v) {_vm.$set(_vm.form, "address_phone", $$v)},expression:"form.address_phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"税号","prop":"tax_number"}},[_c('el-input',{attrs:{"placeholder":"请输入税号","disabled":_vm.id > 0},model:{value:(_vm.form.tax_number),callback:function ($$v) {_vm.$set(_vm.form, "tax_number", $$v)},expression:"form.tax_number"}})],1),_vm._v(" "),(_vm.id > 0)?_c('el-form-item',{attrs:{"label":"附件","prop":"attached_file"}},[_c('div',{staticClass:"view-navbar"},[_c('ul',{staticClass:"clear-both"},_vm._l((_vm.form.attached_file),function(item,index){return _c('li',{key:index},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":item.name,"placement":"bottom"}},[(item.type === 'pic')?_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":item.tmp_url},on:{"click":_vm.onViewImage}}):_vm._e(),_vm._v(" "),(item.type === 'pdf' || item.type === 'eml')?_c('i',{staticClass:"sj-icon-pdf",staticStyle:{"font-size":"100px","margin-top":"50px"},on:{"click":function($event){return _vm.onGetPdfFile(item, index)}}}):_vm._e()])],1)}),0)])]):_c('el-form-item',{attrs:{"label":"添加附件","prop":"attached_file"}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"","auto-upload":false,"on-change":_vm.onChangeFile,"before-remove":_vm.beforeRemove,"multiple":"","limit":5,"on-exceed":_vm.handleExceed,"file-list":_vm.fileList,"accept":".jpg, .jpeg, .png, .pdf, .eml"}},[_c('el-button',{attrs:{"size":"small","loading":_vm.fileUploading,"type":"primary"}},[_vm._v("点击上传\n              ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传PNG/JPG/PDF/EML文件，允许上传多张\n              ")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"使用客户","prop":"customer_ids"}},_vm._l((_vm.form.customer_ids),function(item,index){return _c('div',{key:index,staticClass:"market"},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","margin-top":"4px"}},[_c('remote-select',{attrs:{"placeholder":"请输入关键词","queryRequest":_vm.customerRemoteMethod,"findRequest":_vm.getCustomerInfoRemote,"clearable":"","valueKey":"id","labelKey":"name","idKey":"id"},model:{value:(item.id),callback:function ($$v) {_vm.$set(item, "id", $$v)},expression:"item.id"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","margin-left":"4px"}},[(index === 0)?_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.addCustomer}},[_vm._v("添加")]):_vm._e(),_vm._v(" "),(index > 0)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.deleteItemAt(index)}}},[_vm._v("删除")]):_vm._e()],1)],1)])}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"账期","prop":"pay_condition_ids"}},_vm._l((_vm.form.pay_condition_ids),function(item,index){return _c('div',{key:index,staticClass:"market"},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","margin-top":"4px"}},[_c('remote-select',{attrs:{"placeholder":"请输入账期名称","queryRequest":function (_){ return _vm.queryPayCondition(Object.assign({}, {is_disabled: 0}, _)); },"findRequest":_vm.getPayCondition,"clearable":"","keyword-key":"name","value-key":"id","label-key":"name","id-key":"id"},model:{value:(item.id),callback:function ($$v) {_vm.$set(item, "id", $$v)},expression:"item.id"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","margin-left":"4px"}},[(index === 0)?_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.addConditions}},[_vm._v("添加\n                  ")]):_vm._e(),_vm._v(" "),(index > 0)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.deleteConditionAt(index)}}},[_vm._v("删除\n                  ")]):_vm._e()],1)],1)])}),0)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","disabled":_vm.fileUploading,"native-type":"submit"}},[_vm._v("保存\n        ")]),_vm._v(" "),(_vm.id > 0)?_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")]):_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptForm_vue__ = __webpack_require__(1927);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a446ce8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptForm_vue__ = __webpack_require__(2157);
function injectStyle (ssrContext) {
  __webpack_require__(2155)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a446ce8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a446ce8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/customer-receipt-form.4080f63d700612cd83fd.js